<div class="card">
  <a
    [routerLink]="['/blog', item?.slug]"
    class="w-100 text-decoration-none text-dark"
  >
    <div class="article-card shadow-sm rounded h-100 d-flex flex-column">
      <div class="position-relative">
        <img
          [src]="item.thumbnailInfo?.cdnUrl || 'assets/images/default.jpg'"
          [alt]="item.bannerInfo?.[0]?.metadata?.altTag || item.basicInfo?.title"
          class="img-fluid rounded-top blog-card-image"
        />
        <span class="article-tag">{{
          item?.categoryInfo?.title || "General"
        }}</span>

        @if (item?.views && showViews) {
        <span class="views-tag"
          ><i class="fa fa-eye"></i> {{ item?.views }}</span
        >
        }
      </div>
      <div
        class="p-4 text-start d-flex flex-column flex-grow-1 article-card-content"
        [ngClass]="{ 'show-desc': showDescription }"
      >
        <h5 class="fw-normal mb-0 flex-grow-1 h-truncate" [title]="item?.title">
          {{ item?.title }}
        </h5>
        @if (showDescription) {
        <!-- <p class="text-muted small mb-2">
          {{
            item?.summary || "Explore this insightful article on luxury stays."
          }}
        </p> -->
        <p class="text-muted small mb-0 mt-2">
          {{ item.publishedAt | date : "dd MMMM yyyy" }}
        </p>
        }
      </div>
    </div>
  </a>
</div>
